import styled from 'styled-components'
import { themeColorBlue, white } from '@edulastic/colors'
import { getBorderColor, getBackgroundColor, getTextColor } from './utils'

export const TabsContainer = styled.div`
  width: 100%;
`

export const TabList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (max-width: 768px) {
    margin-top: 20px;
    position: relative;
    display: flex;
    flex-direction: row;
    overflow: auto;
  }
`

export const TabItem = styled.li`
  margin: 0;
  padding: 0;
`

export const TabButton = styled.button`
  font-weight: 600;
  padding: 0px 15px;
  min-height: 24px;
  height: auto;
  color: ${(props) => getTextColor(props)};
  border: 1px solid ${(props) => getBorderColor(props)};
  border-radius: 4px;
  margin-left: 10px;
  min-width: 85px;
  font-size: ${(props) =>
    props.theme?.headerFilters?.headerFilterTextSize || '14px'};
  background: ${(props) => getBackgroundColor(props)};
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;

  &:focus {
    outline: 2px solid ${themeColorBlue} !important;
    outline-offset: 2px;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    border: 1px solid ${(props) => getBorderColor(props)};
  }

  &:hover {
    color: ${white};
    background: ${themeColorBlue};
    border-color: ${themeColorBlue};
  }

  &:not(:hover) {
    color: ${(props) => getTextColor(props)};
    background: ${(props) => getBackgroundColor(props)};
    border: 1px solid ${(props) => getBorderColor(props)};
  }
`

export const TabPanel = styled.div`
  padding: 16px 0;

  &[hidden] {
    display: none;
  }
`
